<template>
  <div v-if="about">
    <!-- Investor Information -->
    <h3 class="mb-5">Investor Information</h3>
    <div class="h4 mb-5">顯示於AboutUs頁面</div>
    <!-- Call to Action -->
    <label class="form-item py-5 d-flex">
      <h4 class="w-180px">Call to Action</h4>
      <div class="flex-grow-1 flex-basis-0">
        {{ about.investor_call_to_action }}
      </div>
    </label>
    <!-- img uploader -->
    <div class="form-item py-5 d-flex">
      <div class="w-180px">
        <h4 class="mb-10px">Visual</h4>
      </div>
      <div class="flex-grow-1 d-flex justify-end">
        <div
          class="w-305px h-187px bg-cover bg-center"
          :style="{
            'background-image': `url(${about.investor_visual})`,
            'border-radius': '6.2px',
          }"
        ></div>
      </div>
    </div>
    <!-- Title -->
    <label class="form-item py-5 d-flex">
      <h4 class="w-180px">Title</h4>
      <div class="flex-grow-1 flex-basis-0">
        {{ about.investor_relations_title }}
      </div>
    </label>
    <!-- Investor Relations Contact -->
    <div class="form-item py-5 d-flex">
      <h4 class="w-180px" style="flex-shrink: 0;">
        Content
      </h4>
      <div class="flex-grow-1 flex-basis-0 link-decoration-none"
           v-html="about.investor_relations_contact">
      </div>
    </div>
    <!-- Title -->
    <label class="form-item py-5 d-flex">
      <h4 class="w-180px">Title</h4>
      <div class="flex-grow-1 flex-basis-0">
        {{ about.investor_agent_title }}
      </div>
    </label>
    <!-- Transfer Agent Contact -->
    <div class="form-item py-5 d-flex">
      <h4 class="w-174px mr-6px" style="flex-shrink: 0;">
        Content
      </h4>
      <div class="flex-grow-1 flex-basis-0 link-decoration-none"
           v-html="about.investor_agent_contact">
      </div>
    </div>

    <!-- Quick Link -->
    <h3 class="my-5">Quick Link</h3>
    <div class="h4 mb-5">可編輯文字及連結，可擴充</div>
    <div v-for="(item, i) in about.investor_quick_link" :key="i">
      <!-- Label -->
      <label class="form-item d-flex py-5">
        <h5 class="w-174px pr-5">Label {{ i + 1 }}</h5>
        <div class="flex-grow-1 flex-basis-0">
          {{ item.label }}
        </div>
      </label>
      <!-- URL -->
      <label class="form-item d-flex py-5">
        <h5 class="w-174px pr-5">URL</h5>
        <div class="flex-grow-1 flex-basis-0">
          <a :href="item.url" class="text-decoration-none">{{ item.url }}</a>
        </div>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    about: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    addItem() {
      const template = {
        id: Date.now(),
        label: `label ${Date.now()}`,
        url: '',
      };
      this.itemList.push(template);
    },
  },
};
</script>

<style></style>
